// Адаптер над Vuex-модулем `@emcd-shared/auth-service/store`.
//
// Даёт вьюхам/хукам читать auth-состояние (2FA/secure, авторизация,
// preferredFiat) через геттеры стора, не лазая в vuex-строки напрямую и не
// дублируя логику в pinia. Единственный источник правды по auth — auth-service;
// здесь только чтение.
//
// secure наполняется dispatch auth/loadSecure, profile — auth/loadProfile.
import { computed } from "vue";
import store from "@/store";

const g = (name) => store.getters[`auth/${name}`];

// Суффикс автогенерируемого email для TG-юзера без собственной почты
// (backend-домен авторизации). Константа — её же импортируют тесты.
// "ecmd" уже норм
export const TG_GENERATED_EMAIL_SUFFIX = "@tg.ecmd.auth";

export function useAuth() {
  // Сырой ответ /profile/2fa_setup
  const secure = computed(() => store.state.auth.secure || {});

  const isTwoFaGoogle = computed(() => g("isTwoFaGoogle"));
  const isTwoFaPhone = computed(() => g("isTwoFaPhone"));
  const isPhoneEnabled = computed(() => g("isPhoneEnabled"));
  const twoFaMethod = computed(() => g("twoFaMethod"));
  // Паскей-геттера в auth-service нет — читаем из secure напрямую.
  const isPasskeyEnabled = computed(
    () => !!secure.value.is_2fa_passkey_enabled,
  );

  const isAuthorized = computed(() => g("isAuthorized"));
  const preferredFiat = computed(() => g("preferredFiat"));
  // segment_id из auth-профиля (= state.profile.segment_id). Может быть пустым
  // до загрузки профиля (loadProfile) — потребители держат JWT-fallback
  // (analytics/base.js identify).
  const analyticsUserId = computed(() => g("analyticsUserId"));

  // Профиль из auth-service
  const profile = computed(() => store.state.auth.profile || {});
  // Собственный email юзера, а не автосгенерированный
  const hasOwnEmail = computed(() => {
    const email = profile.value?.email;
    return !!email && !email.endsWith(TG_GENERATED_EMAIL_SUFFIX);
  });

  return {
    secure,
    isTwoFaGoogle,
    isTwoFaPhone,
    isPhoneEnabled,
    twoFaMethod,
    isPasskeyEnabled,
    isAuthorized,
    preferredFiat,
    analyticsUserId,
    profile,
    hasOwnEmail,
  };
}
